import { Trans, useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import DatePicker from '@/common/components/DatePicker/DatePicker'

import { getPreviewDateHint } from './helpers'
import * as Styles from './styles'

const PreviewDateScenario = ({ previewDate, onChangePreviewDate, dateLimitedBlocks }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const hint = getPreviewDateHint(dateLimitedBlocks)
  const dateInputProps = { placeholder: t('Selecciona una fecha'), 'aria-label': t('Fecha de la preview') }

  return (
    <Styles.Container>
      <Styles.Intro>
        <Text type="titleM">{t('Fecha de la preview')}</Text>
        <Text type="bodySRegular" color={theme.colors.text.muted}>
          {t(
            'Simula cómo se ve la página en una fecha concreta. Los criterios basados en tiempo se actualizan automáticamente.'
          )}
        </Text>
      </Styles.Intro>
      <Styles.DateField>
        <DatePicker
          value={previewDate}
          onChange={onChangePreviewDate}
          inputProps={dateInputProps}
          fullWidth
          clearable
        />
        {hint && (
          <Text type="bodySRegular">
            <Trans i18nKey={hint.key} values={hint.values} components={{ bold: <strong /> }} />
          </Text>
        )}
      </Styles.DateField>
    </Styles.Container>
  )
}

export default PreviewDateScenario
